import type { ReactNode } from 'react';
import { Alert, EmptyState } from '../../ui/States.js';
import { Spinner } from '../../ui/Button.js';

/**
 * Compatibilité : états historiques de l'espace garage, rendus par `src/ui/States`.
 * Code neuf : `Alert`, `EmptyState`, `SkeletonList` depuis `src/ui`.
 */
export function Loading({ label = 'Chargement…' }: { label?: string }) {
  return (
    <div
      role="status"
      className="flex items-center justify-center gap-3 py-12 text-sm font-medium text-ink-3"
    >
      <Spinner className="text-ink-3" />
      {label}
    </div>
  );
}

export function ErrorBox({ message, onRetry }: { message: string; onRetry?: () => void }) {
  return (
    <Alert
      tone="danger"
      action={
        onRetry ? (
          <button
            type="button"
            onClick={onRetry}
            className="min-h-(--ctl-sm) font-medium underline underline-offset-4"
          >
            Réessayer
          </button>
        ) : undefined
      }
    >
      <p>{message}</p>
    </Alert>
  );
}

export function Notice({
  tone = 'info',
  children,
}: {
  tone?: 'info' | 'success' | 'warning';
  children: ReactNode;
}) {
  return (
    <Alert tone={tone === 'info' ? 'neutral' : tone} role="status" className="text-sm">
      {children}
    </Alert>
  );
}

export function Empty({ children }: { children: ReactNode }) {
  return <EmptyState compact>{children}</EmptyState>;
}
